// Helpers
import bobtailAPI from "../axiosConfig"
import { captureSentryTransaction } from '../sentryMixin'

export default class Reports {
  static baseUrl = "/api/reports"

  static async getAnnualReport (params) {
    const transaction = captureSentryTransaction('GET client-annual-report', 'report')
    const response = await (await bobtailAPI()).get(`${Reports.baseUrl}/client-annual`, {
      params,
    })
    await transaction.finish()
    return response
  }

  static async sendAnnualReport (params) {
    return (await bobtailAPI()).post(`${Reports.baseUrl}/client-annual/send`, params)
  }
}
